import { stringify } from "../../util/querystring-util";
import {
  UpdateTicketRequest,
  UpdateTicketResponse,
  UpdateTicketStatusMemoRequest,
  UpdateTicketStatusMemoResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";
import { GetInfraTaskTicketRequest } from "./get-infra-task-ticket/GetInfraTaskRequest";
import { GetInfraTaskTicketResponse } from "./get-infra-task-ticket/GetInfraTaskResponse";

interface TicketRestResource {
  updateTicket(request: UpdateTicketRequest): Promise<UpdateTicketResponse>;
  updateInfraTaskTicket(
    request: UpdateTicketRequest,
  ): Promise<UpdateTicketResponse>;
  getInfraTaskTicket(
    request: GetInfraTaskTicketRequest,
  ): Promise<GetInfraTaskTicketResponse>;
  updateTicketStatusMemo(
    request: UpdateTicketStatusMemoRequest,
  ): Promise<UpdateTicketStatusMemoResponse>;
}

const REST_RESOURCE_NAME = `/ticket`;

/**
 * PUT /ticket/{ticketId}
 */
const updateTicket = restResourceRequester<
  UpdateTicketRequest,
  UpdateTicketResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME}/${request.tcktId}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /ticket/infra-task-ticket/{ticketId}
 */
const updateInfraTaskTicket = restResourceRequester<
  UpdateTicketRequest,
  UpdateTicketResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME}/infra-task-ticket/${request.tcktId}`,
  (request) => JSON.stringify(request),
);

/**
 * GET /ticket/infra-task-ticket
 */
const getInfraTaskTicket = restResourceRequester<
  GetInfraTaskTicketRequest,
  GetInfraTaskTicketResponse
>(
  "GET",
  (request) => `${REST_RESOURCE_NAME}/infra-task-ticket?${stringify(request)}`,
);

/**
 * PUT /ticket/{pjtId}/memo
 */
const updateTicketStatusMemo = restResourceRequester<
  UpdateTicketStatusMemoRequest,
  UpdateTicketStatusMemoResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME}/${request.pjtId}/memo`,
  (request) => JSON.stringify(request),
);

export const ticketRestResource: TicketRestResource = {
  updateTicket: updateTicket,
  updateInfraTaskTicket: updateInfraTaskTicket,
  getInfraTaskTicket: getInfraTaskTicket,
  updateTicketStatusMemo: updateTicketStatusMemo,
};
